const ITEMS = [
  "STRATEGY",
  "STORY",
  "DESIGN",
  "TECHNOLOGY",
  "AUTOMATION",
  "ANALYTICS",
];

const Row = () => (
  <div className="flex items-center">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center">
        <span
          className={`font-display text-2xl font-extrabold tracking-[0.18em] sm:text-3xl ${
            i % 2 === 1 ? "text-transparent" : "text-slate-600"
          }`}
          style={i % 2 === 1 ? { WebkitTextStroke: "1px rgba(212,175,55,0.55)" } : undefined}
        >
          {item}
        </span>
        <span className="mx-10 inline-block h-2.5 w-2.5 rotate-45 bg-gold/60" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative select-none overflow-hidden border-y border-navyline/60 bg-navy/50 py-7"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
